module.exports = __webpack_public_path__ + "img/default.60241381.png";